export function parseLogRecord(item) {
  if (typeof item === "string") {
    try {
      return JSON.parse(item);
    } catch {
      return { message: item, category: "info", level: "info" };
    }
  }

  if (item?.message && typeof item.message === "string") {
    try {
      return { ...JSON.parse(item.message), timestamp: item.timestamp };
    } catch {
      return item;
    }
  }

  return item || {};
}

export function getLogLevel(item) {
  const parsed = parseLogRecord(item);
  return (parsed.level || parsed.severity || "info").toLowerCase();
}

export function matchesLogCriteria(item, criteria) {
  const parsed = parseLogRecord(item);
  return Object.entries(criteria).some(([key, value]) => parsed[key] === value);
}
